import { useState, useEffect,memo } from "react";
import { motion } from "framer-motion";

const MapSection = ({ lng }) => {
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowMap(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  if (!showMap) return null;

  return (
    <section className="relative py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {lng === "ar" ? "موقعنا" : "Our Location"}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {lng === "ar"
              ? "اكتشف مواقع منشآتنا ومرافقنا المنتشرة في جميع أنحاء المنطقة"
              : "Discover the locations of our facilities and operations spread across the region"}
          </p>
        </motion.div>

        <div className="w-full h-96 rounded-2xl overflow-hidden shadow-2xl border border-gray-200">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3450.496567179586!2d31.42878782394179!3d30.13721601416835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458174638e5254b%3A0x5517a78f23acc6b5!2z2KzZh9in2LIg2YXYtNix2YjYudin2Kog2KfZhNiu2K_ZhdipINin2YTZiNi32YbZitip!5e0!3m2!1sar!2seg!4v1763637177447!5m2!1sar!2seg"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default memo(MapSection);